import "./Checkout.module.css";
import Header from "@/reusable_sections/Header";
import Checkout from "./sections/Checkout";
import Footer from "@/reusable_sections/Footer";
export default function CheckoutPage() {
  return <div>
      <Header />
      <Checkout />
      <Footer />
    </div>;
}